<template>
    <v-data-table
        :headers="realHeaders"
        :items="list"
        class="elevation-1"
        :items-per-page="-1"
        hide-default-footer
    >
        <template #item="row">
            <tr>
                <td v-for="(header, i) in realHeaders.slice(0, -1)" :key="i">
                    {{ getCellValue(row.item, header) }}
                </td>
                <td style="text-align: right;">
                    <v-btn icon color="primary" @click="editItem(row.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="deleteItem(row.item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import {TableHeader} from '@/components/common/TableHeader'
import {User} from '@/models/User'
import Browser from '@/mixins/Browser'

type Header = TableHeader<User>

@Component
export default class UserBrowser extends Browser<User>
{
    defaultHeaders: Header[] = [
        {text: 'ID', value: 'id', align: 'start'},
        {text: 'Имя', value: 'display_name'},
        {text: 'Логин', value: 'username'},
        {text: 'Роль', value: 'roleLabel'},
        {text: '', value: null},
    ]

    async fetchList() {
        this.list = await this.api.listUsers({...this.filters, expand: ['roleLabel']})
    }

    getModelDisplayName(isSecondCase: boolean): string {
        return isSecondCase ? 'пользователя' : 'пользователь'
    }

    getModelDisplayId(user: User): string {
        return `"${user.username}"`
    }

    getCellValue(user: User, header: Header): string {
        if (header.value == null) {
            return ''
        }
        return header.value instanceof Function ? header.value(user) : (user[header.value] + '')
    }

    async deleteModel(user: User): Promise<boolean> {
        return await this.api.deleteUser(user.id)
    }
}
</script>
